const getCookieToken = () => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; token=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

// Config uses a getter so the token is read from the cookie at request time,
// not once at module load — this ensures token refreshes are picked up automatically.
export const Config = {
  get headers() {
    return { Authorization: `Bearer ${getCookieToken()}` };
  },
};


